jQuery_T4NT(document).ready(function ($) {
  const customSizeInputs = document.querySelectorAll('#CustomSizeTab input');

  // Prevent negative values and sync custom sizes
  customSizeInputs.forEach(function (input) {
    input.addEventListener('input', function () {
      const value = parseFloat(this.value);

      if (!Number.isNaN(value) && value < 0) {
        this.value = 0;
      }

      if (!this.id) return;

      const cartFusionInput = document.querySelector(
        `.cartFusion_fbt_wrapper input[id="${CSS.escape(this.id)}"]`
      );

      if (cartFusionInput && cartFusionInput !== this) {
        cartFusionInput.value = this.value;
        cartFusionInput.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }
    });
  });

  $(document).on('variant:changed', function (evt) {
    const variant = evt.currentVariant;

    if (!variant) return;

    const cartFusionOption = document.querySelector(
      `.cartFusion_fbt_item select option[value="${variant.id}"]`
    );

    if (cartFusionOption) {
      const cartFusionSelect = cartFusionOption.closest('select');

      if (
        cartFusionSelect &&
        cartFusionSelect.value !== String(variant.id)
      ) {
        cartFusionSelect.value = String(variant.id);
        cartFusionSelect.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    }

    const isCustomVariant = (variant.title || '')
      .toLowerCase()
      .includes('custom');

    customSizeInputs.forEach(function (input) {
      input.disabled = !isCustomVariant;
    });

    // Update size drawer
    if (typeof variant_element === 'function') {
      variant_element(
        [variant.option1, variant.option2].filter(Boolean).join(' / ')
      );
    }

    const actionTrigger = document.querySelector(
      '.cartFusion_fbt_action_trigger'
    );
    const soldOutButton = document.querySelector('.soldOutButton');

    const isSoldOut =
      variant.available === false ||
      Boolean(cartFusionOption && cartFusionOption.disabled);

    if (actionTrigger) {
      actionTrigger.style.display = isSoldOut ? 'none' : 'block';
    }

    if (soldOutButton) {
      soldOutButton.hidden = !isSoldOut;
    }
  });

  // Hide zero prices
  function hideZeroPrices() {
    document.querySelectorAll(
      '.cartFusion_fbt_wrapper .pitemprice'
    ).forEach(function (priceElement) {
      const moneyElement = priceElement.querySelector('.money');

      if (!moneyElement) return;

      const numericPrice = parseFloat(
        moneyElement.textContent.replace(/[^0-9.-]/g, '')
      );

      priceElement.style.display =
        !Number.isNaN(numericPrice) && numericPrice === 0
          ? 'none'
          : '';
    });
  }

  hideZeroPrices();

  // Watch price updates inside existing Cart Fusion wrappers
  document.querySelectorAll('.cartFusion_fbt_wrapper').forEach(
    function (wrapper) {
      const observer = new MutationObserver(hideZeroPrices);

      observer.observe(wrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  );
});